var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_vm._l((_vm.headers),function(header){return _c('th',{key:header.text,class:{
      'column': true,
      'text-xs-left': header.align === 'left' || !header.align,
      'text-xs-center': header.align === 'center',
      'text-xs-right': header.align === 'right',
      'sortable': header.sortable,
      'desc': _vm.paginacion.descending,
      'asc': !_vm.paginacion.descending,
      'active': header.value === _vm.paginacion.sortBy
    },on:{"click":function($event){return _vm.changeSort(header)}}},[_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(header.sortable),expression:"header.sortable"}],attrs:{"small":""}},[_vm._v("arrow_upward")]),_vm._v("\n    "+_vm._s(header.text)+"\n  ")],1)}),_c('th',{staticClass:"text-xs-right"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }